import { Login } from "../../components";

const LoginScreen = () => {
  return (
    <div>
      <Login/>
    </div>
  );
};

export default LoginScreen;